// TODO(DWA-191): Remove. Anti-corruption seam: adapts a camelCase invoice
// datatable row to the snake_case shape the legacy Settle/Merge modals still
// read. Those modals are shared with Reservations/POS, which feed snake_case
// from the not-yet-migrated invoices endpoints. Delete this once DWA-191's
// follow-up camelizes those endpoints + modals.
export const toLegacyInvoiceShape = (invoice) =>
  invoice && {
    ...invoice,
    total_amount: invoice.totalAmount,
    payment_method: invoice.paymentMethod ?? null,
    billing_container_id: invoice.billingContainerId,
    allows_partial_refund: invoice.allowsPartialRefund,
    due_date: invoice.dueDate,
  }
